import React, { useState } from 'react'
import '../index.scss'

import {
    Header,
    HeaderGlobalAction,
    HeaderGlobalBar,
    HeaderMenu,
    HeaderMenuItem,
    HeaderName,
    HeaderNavigation,
    HeaderPanel,
    Modal,
    Switcher,
    SwitcherDivider,
    SwitcherItem,
    ExpandableSearch
} from 'carbon-components-react'

import {
    Notification20,
    AppSwitcher20,
    UserAvatar20,
    Locked16,
} from '@carbon/icons-react'

const style = {
    switcher: {
        textAlign: "left !important",
    },
    boldText: {
        fontWeight: 'bold !important',
        fontSize: '2rem !important'
    },
    switcherIcon: {
        marginRight: ".2em",
        verticalAlign: "bottom"
    },
    appSearch: {
        width: "30em"
    }
}

function AppBar(props) {
    const [state, setState] = useState({})
    const [panel, setPanel] = useState({})
    const [user] = useState(props.user)
    const [search, setSearch] = useState(false)

    const togglePanels = (target) => (event) => {
        if (target == panel.target) {
            setPanel({ target: target, expanded: !panel.expanded })
        } else {
            setPanel({ target: target, expanded: true })
        }
    }

    const toggleSearch = () => {
        setSearch(!search)
    }

    const copyToken = (event) => {
        navigator.clipboard.writeText('HermesToken').then(function () {
            /* clipboard successfully set */
        }, function () {
            /* clipboard write failed */
        })
    }

    const showPermissionsModal = () => {
        setState((state) => {
            return { ...state, permissionModalOpen: !state.permissionModalOpen }
        })
    }

    return (
        <div>
            <Header aria-label={props.appName ? props.appName : ""}>
                <HeaderName prefix={props.appName ? "BD DevOps | " : "BD DevOps"}>
                    {props.appName ? props.appName : ""}
                </HeaderName>
                <HeaderNavigation aria-label={props.appName ? props.appName : ""}>
                    <HeaderMenuItem href="/">Home</HeaderMenuItem>
                    {/* Dynamic Links */}
                    {props && props.links ?
                        props.links.map((link, index) => {
                            return <HeaderMenuItem key={link.name} href={link.url} onClick={link.onClick}>{link.name}</HeaderMenuItem>
                        })
                        : null
                    }
                    {/* Dynamic Menu's */}
                    {props && props.menus ?
                        props.menus.map((menu, index) => {
                            return <HeaderMenu aria-label={menu.name} menuLinkName={menu.name}>
                                {menu.items.map(item => {
                                    return <HeaderMenuItem href={item.url} onClick={item.onClick}>{item.name}</HeaderMenuItem>
                                })}
                            </HeaderMenu>
                        })
                        : null
                    }
                </HeaderNavigation>
                <HeaderGlobalBar>
                    {props.search ?
                        <ExpandableSearch style={style.searchBox} placeHolderText="Search" />
                        : null
                    }
                    {props.notifications ?
                        <HeaderGlobalAction
                            aria-label="Notifications"
                            isActive={panel.target == 'notify' && panel.expanded}
                            onClick={togglePanels('notify')}>
                            <Notification20 />
                        </HeaderGlobalAction>
                        : null
                    }
                    <HeaderGlobalAction
                        aria-label="User Profile"
                        style={style.navButton}
                        isActive={panel.target == 'user' && panel.expanded}
                        onClick={togglePanels('user')}>
                        <UserAvatar20 />
                    </HeaderGlobalAction>
                    <HeaderGlobalAction
                        aria-label="App Switcher"
                        tooltipAlignment="end"
                        isActive={panel.target == 'app' && panel.expanded}
                        onClick={togglePanels('app')}
                    >
                        <AppSwitcher20 />
                    </HeaderGlobalAction>
                </HeaderGlobalBar>
                {/* User */}
                <HeaderPanel id="userpanel" aria-label="Header Panel" style={{bottom: 'unset !important'}} expanded={panel.target == 'user' && panel.expanded}>
                    <Switcher aria-label="Switcher Container">
                        <SwitcherItem >
                            {user}
                        </SwitcherItem>
                        <SwitcherItem onClick={copyToken}>
                            Hermes Token
                        </SwitcherItem>
                        <SwitcherDivider />
                        <SwitcherItem onClick={props.signOut}>
                            Sign Out
                        </SwitcherItem>
                    </Switcher>
                </HeaderPanel>
                {/* Notification */}
                <HeaderPanel aria-label="Header Panel" expanded={panel.target == 'notify' && panel.expanded}>
                    <Switcher aria-label="Switcher Container">
                        {/* Should be a dynamic list pulling from an API, potentially Lambda */}
                        <SwitcherItem style={style.switcher}>
                            Notifications
                        </SwitcherItem>
                        <SwitcherDivider />
                    </Switcher>
                </HeaderPanel>
                {/* AppSwitcher */}
                <HeaderPanel aria-label="Header Panel" expanded={panel.target == 'app' && panel.expanded}>
                    <Switcher aria-label="Switcher Container" style={style.switcher}>
                        <SwitcherItem href="/">
                            {props.appName}
                        </SwitcherItem>
                        <SwitcherDivider />

                        {props.appLinks.map(link => {
                            if(link.name != props.appName)
                            return <SwitcherItem href={link.url} style={style.boldText}>
                                {link.name}
                            </SwitcherItem>
                        })}

                    </Switcher>
                </HeaderPanel>
            </Header>
            <Modal modalHeading={"Whoaa buddy...Can I see some ID?"}
                modalLabel={"Permissions Error"}
                primaryButtonText={"Bugger Off"}
                open={state.permissionModalOpen}
                onRequestClose={showPermissionsModal}
                onRequestSubmit={showPermissionsModal}>
                <p>
                    Look, let's be honest, sometimes there are things that you shouldn't do...
                    this may be one of them. If you think you're supposed to go here, how about
                    you reach out to DevOps and see if they think the same way
                </p>
            </Modal>
        </div>
    )
}


export default AppBar